<template>
  <main class="main profile-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="profile-form">
            <div class="profile-form-wrapper">
              <div class="left">
                <div class="menu">
                  <div class="user-card">
                    <div class="profile-info">
                      <div class="profile-info__icon">
                        <img src="@/assets/user.svg" alt="" class="user" />
                      </div>
                      <div class="profile-info__info">
                        <div class="full-name">{{ name }} {{ surname }}</div>
                        <a :href="`mailto:${email}`" class="email">{{
                          email
                        }}</a>
                        <div class="phone">{{ phone }}</div>
                      </div>
                    </div>
                  </div>
                  <ul class="menu__sections">
                    <li v-for="item in nav" :key="item.page">
                      <router-link
                        :class="{ active: item.page === $route.params.page }"
                        :to="{ name: 'Profile', params: { page: item.page } }"
                      >
                        {{ item.title }}
                      </router-link>
                    </li>
                    <li>
                      <a @click.prevent="$parent.logout"> Log out </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="right">
                <div
                  class="content"
                  v-if="activeProfilePage === 'order-history'"
                >
                  <div class="content-wrapper">
                    <div
                      class="table-container table-container-depositHistory table-container-createdHistory"
                    >
                      <div class="table">
                        <table>
                          <thead>
                            <tr
                              v-if="
                                $parent.orderHistory &&
                                $parent.orderHistory.length
                              "
                            >
                              <td>
                                <div class="td-wrapper">{{ $t("Date") }}</div>
                              </td>
                              <td>
                                <div class="td-wrapper">{{ $t("Item") }}</div>
                              </td>
                              <td>
                                <div class="td-wrapper">{{ $t("Name") }}</div>
                              </td>
                              <td>
                                <div class="td-wrapper">{{ $t("Format") }}</div>
                              </td>
                              <td>
                                <div class="td-wrapper">{{ $t("Price") }}</div>
                              </td>
                              <td>
                                <div class="td-wrapper"></div>
                              </td>
                            </tr>
                            <tr v-else>
                              <td></td>
                            </tr>
                          </thead>
                          <tbody
                            v-if="
                              $parent.orderHistory &&
                              !$parent.orderHistory.length
                            "
                          >
                            <tr>
                              <td class="bold">
                                {{
                                  $t(
                                    "Unfortunately, you don't have a purchase history yet."
                                  )
                                }}
                              </td>
                            </tr>
                          </tbody>
                          <tbody
                            v-for="(item, i) in $parent.orderHistory"
                            :key="'b' + i"
                          >
                            <template v-for="(itemPart, i) in item.items">
                              <OrderHistoryRow
                                :class="{
                                  'full-underline':
                                    itemPart.product_type !== 'pack',
                                }"
                                :key="'a' + i"
                                :itemData="{
                                  ...itemPart.info,
                                  pack_items: itemPart.pack_items,
                                }"
                                :status="item.status"
                                :created_at="itemPart.created_at"
                                :dimensions="itemPart.dimensions"
                                :price="itemPart.price"
                                :imgDomain="$parent.imgDomain"
                                :currency="$parent.currency"
                                :formatOptions="
                                  itemPart.info.product_type == 'doc'
                                    ? docFormatOptions
                                    : formatOptions
                                "
                                :activeDownloadSize.sync="activeDownloadSize"
                                :activeDownloadFormat.sync="
                                  activeDownloadFormat
                                "
                                :activeDocDownloadFormat.sync="
                                  activeDocDownloadFormat
                                "
                                @download="downloadProduct"
                              />

                              <template
                                v-if="itemPart.info.product_type === 'pack'"
                              >
                                <OrderHistoryRow
                                  v-for="(packItem, i) in itemPart.pack_items"
                                  :class="{
                                    'full-underline':
                                      itemPart.pack_items &&
                                      itemPart.pack_items.length - 1 === i,
                                  }"
                                  :is-pack-item="true"
                                  :key="'c' + i"
                                  :itemData="{
                                    id: packItem.id,
                                    title: packItem.title,
                                    doc_url: packItem.doc_url,
                                    product_type: 'image',
                                  }"
                                  :status="item.status"
                                  :created_at="itemPart.created_at"
                                  :dimensions="packItem.dimensions"
                                  :price="itemPart.price"
                                  :imgDomain="$parent.imgDomain"
                                  :currency="$parent.currency"
                                  :formatOptions="formatOptions"
                                  :activeDownloadSize.sync="activeDownloadSize"
                                  :activeDownloadFormat.sync="
                                    activeDownloadFormat
                                  "
                                  :activeDocDownloadFormat.sync="
                                    activeDocDownloadFormat
                                  "
                                  @download="downloadProduct"
                                />
                              </template>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="content"
                  :class="[activeProfilePage]"
                  v-else-if="activeProfilePage === 'my-work'"
                >
                  <div class="tab-list">
                    <div
                      :class="[
                        'item title small',
                        { active: activeMyProductsTab == item.page },
                      ]"
                      v-for="item in myProductsTabs"
                      :key="'a' + item.page"
                      @click="setActiveMyProductsTab(item.page)"
                    >
                      {{ $t(item.title) }}
                    </div>
                  </div>
                  <button class="button blue" @click="$parent.goToPromtCreate">
                    <img src="./../assets/create.svg" class="image" />
                    {{
                      $t(
                        activeMyProductsTab === "art"
                          ? "Create new art"
                          : "Create new text"
                      )
                    }}
                  </button>
                  <!-- <div class="title">{{  createdHistory  }}</div>
                  <div class="title">{{  createdHistoryImage  }}</div> -->
                  <div class="content-wrapper">
                    <div
                      class="table-container table-container-depositHistory table-container-createdHistory"
                      v-if="activeMyProductsTab === 'art'"
                    >
                      <div class="table">
                        <table>
                          <thead>
                            <tr
                              v-if="
                                createdHistoryImage &&
                                createdHistoryImage.length
                              "
                            >
                              <td>
                                <div class="td-wrapper">{{ $t("Design") }}</div>
                              </td>
                              <td>
                                <div class="td-wrapper">{{ $t("Name") }}</div>
                              </td>
                              <td>
                                <div class="td-wrapper">
                                  {{ $t("Filters") }}
                                </div>
                              </td>
                              <td>
                                <div class="td-wrapper">{{ $t("Price") }}</div>
                              </td>
                              <td>
                                <div class="td-wrapper">{{ $t("Status") }}</div>
                              </td>
                            </tr>
                            <tr v-else>
                              <td></td>
                            </tr>
                          </thead>
                          <tbody
                            v-if="
                              createdHistoryImage && !createdHistoryImage.length
                            "
                          >
                            <tr class="empty">
                              <td class="bold">{{ $t("Empty") }}</td>
                            </tr>
                          </tbody>
                          <tbody
                            v-if="
                              createdHistoryImage && createdHistoryImage.length
                            "
                          >
                            <tr
                              v-for="(item, i) in createdHistoryImage"
                              :key="i"
                            >
                              <td>
                                <div class="td-wrapper">
                                  <div class="img-container">
                                    <img
                                      v-if="item.doc_type == 'image'"
                                      class="img"
                                      :src="$parent.imgDomain + item.doc_url"
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="td-wrapper">
                                  {{ item.title }}
                                </div>
                              </td>
                              <td>
                                <div
                                  class="td-wrapper"
                                  v-if="
                                    item.category_id &&
                                    categoryOptions &&
                                    categoryOptions.length
                                  "
                                >
                                  <span
                                    v-if="
                                      categoryOptions.find(
                                        (obj) => obj.id === item.category_id
                                      )
                                    "
                                    >{{
                                      $t(
                                        categoryOptions.find(
                                          (obj) => obj.id === item.category_id
                                        ).title
                                      )
                                    }}</span
                                  >
                                </div>
                              </td>
                              <td class="price">
                                <div class="td-wrapper">
                                  {{ item.user_price }} {{ $parent.currency }}
                                </div>
                              </td>
                              <td>
                                <div
                                  class="td-wrapper offer-link"
                                  v-if="item.status == 'offer'"
                                  @click="openOffer(item)"
                                >
                                  {{ $t("Offer") }}
                                </div>
                                <div class="td-wrapper" v-else>
                                  {{ item.status }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div
                      class="table-container table-container-depositHistory table-container-createdHistory"
                      v-if="activeMyProductsTab === 'text'"
                    >
                      <div class="table">
                        <table>
                          <thead>
                            <tr
                              v-if="
                                createdHistoryText && createdHistoryText.length
                              "
                            >
                              <td>
                                <div class="td-wrapper">{{ $t("Design") }}</div>
                              </td>
                              <td>
                                <div class="td-wrapper">{{ $t("Name") }}</div>
                              </td>
                              <td>
                                <div class="td-wrapper">
                                  {{ $t("Description") }}
                                </div>
                              </td>
                              <td>
                                <div class="td-wrapper">
                                  {{ $t("Filters") }}
                                </div>
                              </td>
                              <td>
                                <div class="td-wrapper">{{ $t("Price") }}</div>
                              </td>
                              <td>
                                <div class="td-wrapper">{{ $t("Status") }}</div>
                              </td>
                            </tr>
                            <tr v-else>
                              <td></td>
                            </tr>
                          </thead>
                          <tbody
                            v-if="
                              createdHistoryText && !createdHistoryText.length
                            "
                          >
                            <tr class="empty">
                              <td class="bold">{{ $t("Empty") }}</td>
                            </tr>
                          </tbody>
                          <tbody
                            v-if="
                              createdHistoryText && createdHistoryText.length
                            "
                          >
                            <tr
                              v-for="(item, i) in createdHistoryText"
                              :key="i"
                            >
                              <td>
                                <div class="td-wrapper">
                                  <div
                                    v-if="item.doc_type == 'doc'"
                                    class="doc-img"
                                  >
                                    <img
                                      src="./../assets/doc.svg"
                                      class="image"
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="td-wrapper">
                                  {{ item.title }}
                                </div>
                              </td>
                              <td>
                                <div class="td-wrapper">
                                  {{ item.description }}
                                </div>
                              </td>
                              <td>
                                <div
                                  class="td-wrapper"
                                  v-if="
                                    item.category_id &&
                                    categoryOptions &&
                                    categoryOptions.length
                                  "
                                >
                                  <span
                                    v-if="
                                      categoryOptions.find(
                                        (obj) => obj.id === item.category_id
                                      )
                                    "
                                    >{{
                                      $t(
                                        categoryOptions.find(
                                          (obj) => obj.id === item.category_id
                                        ).title
                                      )
                                    }}</span
                                  >
                                </div>
                              </td>
                              <td class="price">
                                <div class="td-wrapper">
                                  {{ item.user_price }} {{ $parent.currency }}
                                </div>
                              </td>
                              <td>
                                <div
                                  class="td-wrapper offer-link"
                                  v-if="item.status == 'offer'"
                                  @click="openOffer(item)"
                                >
                                  {{ $t("Offer") }}
                                </div>
                                <div class="td-wrapper" v-else>
                                  {{ item.status }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="top"
                  v-else-if="activeProfilePage === 'edit-profile'"
                >
                  <div class="top-wrapper">
                    <div class="left">
                      <img class="avatar img" src="./../assets/user.svg" />
                      <div class="text" v-if="!profileIsEditable">
                        <div class="desc">{{ name }} {{ surname }}</div>
                        <div class="desc">{{ email }}</div>
                        <div class="desc">{{ phone }}</div>
                      </div>
                      <div class="text text-edit" v-else>
                        <div class="desc">
                          <input
                            type="text"
                            :placeholder="$t('Name')"
                            v-model="name"
                          />
                          <input
                            type="text"
                            :placeholder="$t('Surname')"
                            v-model="surname"
                          />
                        </div>
                        <div class="desc">
                          <input
                            type="email"
                            :placeholder="$t('Email')"
                            v-model="email"
                          />
                        </div>
                        <div class="desc">
                          <input
                            type="number"
                            :placeholder="$t('Phone')"
                            v-model="phone"
                          />
                        </div>
                      </div>
                      <transition name="fade">
                        <div class="desc red" v-if="profileUpdateErrorMessaage">
                          {{ profileUpdateErrorMessaage }}
                        </div>
                      </transition>
                      <transition name="fade">
                        <div
                          class="desc green"
                          v-if="profileUpdateSuccessMessaage"
                        >
                          {{ profileUpdateSuccessMessaage }}
                        </div>
                      </transition>
                    </div>
                    <div class="right">
                      <!--<router-link to="/verification" class="button">Verification</router-link>-->
                      <button class="button button-edit" @click="editProfile()">
                        <img class="edit img" src="./../assets/edit.svg" />
                        <span v-if="!profileIsEditable">{{
                          $t("Edit profile")
                        }}</span>
                        <span v-else>Save</span>
                      </button>
                      <button class="button blue" @click="$parent.logout">
                        {{ $t("Log Out") }}
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="top"
                  :class="[activeProfilePage]"
                  v-else-if="activeProfilePage === 'change-password'"
                >
                  <form @submit.prevent="updatePassword" class="top-wrapper">
                    <div class="left">
                      <div class="text text-edit">
                        <div class="desc">
                          <input
                            required
                            type="password"
                            :placeholder="$t('Current password')"
                            v-model="curPass"
                          />
                        </div>
                        <div class="desc">
                          <input
                            required
                            type="password"
                            :placeholder="$t('New password')"
                            v-model="newPass"
                          />
                        </div>
                        <div class="desc">
                          <input
                            required
                            type="password"
                            :placeholder="$t('Repeat new password')"
                            v-model="repeatPass"
                          />
                        </div>
                      </div>
                      <transition name="fade">
                        <div class="desc red" v-if="passUpdateErrorMessaage">
                          {{ passUpdateErrorMessaage }}
                        </div>
                      </transition>
                      <transition name="fade">
                        <div
                          class="desc green"
                          v-if="passUpdateSuccessMessaage"
                        >
                          {{ passUpdateSuccessMessaage }}
                        </div>
                      </transition>
                    </div>
                    <div class="right">
                      <button type="submit" class="button button-edit">
                        <span>{{ $t("Save") }}</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--                            <div class="wrapper">-->
              <!--                              <div class="title">-->
              <!--                                My Profile -->
              <!--                                <span v-if="verification_data.status !== 'approved'" v-tooltip="{-->
              <!--                                  content: $t('Please verify your profile'),-->
              <!--                                  placement: 'right',-->
              <!--                                }">-->
              <!--                                  <router-link to="/verification"><img class="img shield" src="./../assets/shield.svg"/></router-link>-->
              <!--                                </span>-->
              <!--                                <span v-if="verification_data.status === 'approved'" v-tooltip="{-->
              <!--                                  content: $t('Your profile is verified'),-->
              <!--                                  placement: 'right',-->
              <!--                                }">-->
              <!--                                  <img class="img shield" src="./../assets/verify.svg"/>-->
              <!--                                </span>-->
              <!--                              </div>-->
              <!--                              <div class="top">-->
              <!--                                <div class="top-wrapper">-->
              <!--                                  <div class="left">-->
              <!--                                    <img class="avatar img" src="./../assets/user.svg"/>-->
              <!--                                    <div class="text" v-if="!profileIsEditable">-->
              <!--                                      <div class="desc">{{ name }} {{ surname }}</div>-->
              <!--                                      <div class="desc">{{ email }}</div>-->
              <!--                                      <div class="desc">{{ phone }}</div>-->
              <!--                                    </div>-->
              <!--                                    <div class="text text-edit" v-else>-->
              <!--                                      <div class="desc">-->
              <!--                                        <input type="text" :placeholder="$t('Name')" v-model="name"/>-->
              <!--                                        <input type="text" :placeholder="$t('Surname')" v-model="surname"/>-->
              <!--                                      </div>-->
              <!--                                      <div class="desc">-->
              <!--                                        <input type="email" :placeholder="$t('Email')" v-model="email"/>-->
              <!--                                      </div>-->
              <!--                                      <div class="desc">-->
              <!--                                        <input type="number" :placeholder="$t('Phone')" v-model="phone"/>-->
              <!--                                      </div>-->
              <!--                                    </div>-->
              <!--                                    <transition name="fade">-->
              <!--                                      <div class="desc red" v-if="profileUpdateErrorMessaage">{{profileUpdateErrorMessaage}}</div>-->
              <!--                                    </transition>-->
              <!--                                    <transition name="fade">-->
              <!--                                      <div class="desc green" v-if="profileUpdateSuccessMessaage">{{profileUpdateSuccessMessaage}}</div>-->
              <!--                                    </transition>-->
              <!--                                  </div>-->
              <!--                                  <div class="right">-->
              <!--                                    &lt;!&ndash;<router-link to="/verification" class="button">Verification</router-link>&ndash;&gt;-->
              <!--                                    <button class="button button-edit" @click="editProfile()">-->
              <!--                                      <img class="edit img" src="./../assets/edit.svg"/>-->
              <!--                                      <span v-if="!profileIsEditable">{{ $t('Edit profile') }}</span>-->
              <!--                                      <span v-else>Save</span>-->
              <!--                                    </button>-->
              <!--                                    <button class="button blue" @click="$parent.logout">{{ $t('Log Out') }}</button>-->
              <!--                                  </div>-->
              <!--                                </div>-->
              <!--                              </div>-->
              <!--                <div class="profile-left">-->
              <!--                  <ul class="nav">-->
              <!--                    <template v-for="(item, i) in profileNav">-->
              <!--                      <li :class="['item', {'active': item.page === activeProfilePage}]" @click="goToProfilePage(item.page)" :key="i">-->
              <!--                        <div class="desc">{{ $t(item.title) }}</div>-->
              <!--                      </li>-->
              <!--                    </template>-->
              <!--                  </ul>-->
              <!--                </div>-->

              <!--                <div class="profile-right">-->
              <!--                                <div class="content" v-if="activeProfilePage === 'my-poducts'">-->
              <!--                                  <div class="tab-list">-->
              <!--                                    <div :class="['item title small', {'active': activeMyProductsTab == item.page}]" v-for="item in myProductsTabs" :key="item.page" @click="setActiveMyProductsTab(item.page)">{{$t(item.title)}}</div>-->
              <!--                                  </div>-->
              <!--                                  <button class="button blue" @click="$parent.goToPromtCreate">-->
              <!--                                    <img src='./../assets/create.svg' class="image"/>-->
              <!--                                    {{$t((activeMyProductsTab === 'art') ? 'Create new art' : 'Create new text')}}-->
              <!--                                  </button>-->
              <!--                                  &lt;!&ndash; <div class="title">{{  createdHistory  }}</div>-->
              <!--                                  <div class="title">{{  createdHistoryImage  }}</div> &ndash;&gt;-->
              <!--                                  <div class="content-wrapper">-->
              <!--                                    <div class="table-container table-container-depositHistory table-container-createdHistory" v-if="activeMyProductsTab === 'art'">-->
              <!--                                      <div class="table">-->
              <!--                                        <table>-->
              <!--                                          <thead>-->
              <!--                                          <tr v-if="createdHistoryImage && createdHistoryImage.length">-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">{{$t('Design')}}</div>-->
              <!--                                            </td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">{{$t('Name')}}</div>-->
              <!--                                            </td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">{{$t('Filters')}}</div>-->
              <!--                                            </td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">{{$t('Price')}}</div>-->
              <!--                                            </td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">{{$t('Status')}}</div>-->
              <!--                                            </td>-->
              <!--                                          </tr>-->
              <!--                                          <tr v-else>-->
              <!--                                            <td></td>-->
              <!--                                          </tr>-->
              <!--                                          </thead>-->
              <!--                                          <tbody v-if="createdHistoryImage && !createdHistoryImage.length">-->
              <!--                                          <tr>-->
              <!--                                            <td class="bold">{{$t('Empty')}}</td>-->
              <!--                                          </tr>-->
              <!--                                          </tbody>-->
              <!--                                          <tbody v-if="createdHistoryImage && createdHistoryImage.length">-->
              <!--                                          <tr v-for="(item,i) in createdHistoryImage" :key="i">-->
              <!--                                            <td><div class="td-wrapper">-->
              <!--                                              <div class="img-container">-->
              <!--                                                <img v-if="item.doc_type == 'image'" class="img" :src="$parent.imgDomain + item.doc_url" />-->
              <!--                                              </div>-->
              <!--                                            </div></td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">-->
              <!--                                                {{item.title}}-->
              <!--                                              </div>-->
              <!--                                            </td>-->
              <!--                                            <td><div class="td-wrapper" v-if="item.category_id && categoryOptions && categoryOptions.length">-->
              <!--                                              <span v-if="categoryOptions.find(obj => obj.id === item.category_id)">{{$t(categoryOptions.find(obj => obj.id === item.category_id).title)}}</span>-->
              <!--                                            </div></td>-->
              <!--                                            <td class="price"><div class="td-wrapper">{{ item.user_price }} {{$parent.currency}}</div></td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper offer-link" v-if="item.status == 'offer'" @click="openOffer(item)">{{$t('Offer')}}</div>-->
              <!--                                              <div class="td-wrapper" v-else>{{ item.status }}</div>-->
              <!--                                            </td>-->
              <!--                                          </tr>-->
              <!--                                          </tbody>-->
              <!--                                        </table>-->
              <!--                                      </div>-->
              <!--                                    </div>-->
              <!--                                    <div class="table-container table-container-depositHistory table-container-createdHistory" v-if="activeMyProductsTab === 'text'">-->
              <!--                                      <div class="table">-->
              <!--                                        <table>-->
              <!--                                          <thead>-->
              <!--                                          <tr v-if="createdHistoryText && createdHistoryText.length">-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">{{$t('Design')}}</div>-->
              <!--                                            </td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">{{$t('Name')}}</div>-->
              <!--                                            </td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">{{$t('Description')}}</div>-->
              <!--                                            </td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">{{$t('Filters')}}</div>-->
              <!--                                            </td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">{{$t('Price')}}</div>-->
              <!--                                            </td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">{{$t('Status')}}</div>-->
              <!--                                            </td>-->
              <!--                                          </tr>-->
              <!--                                          <tr v-else>-->
              <!--                                            <td></td>-->
              <!--                                          </tr>-->
              <!--                                          </thead>-->
              <!--                                          <tbody v-if="createdHistoryText && !createdHistoryText.length">-->
              <!--                                          <tr>-->
              <!--                                            <td class="bold">{{$t('Empty')}}</td>-->
              <!--                                          </tr>-->
              <!--                                          </tbody>-->
              <!--                                          <tbody v-if="createdHistoryText && createdHistoryText.length">-->
              <!--                                          <tr v-for="(item,i) in createdHistoryText" :key="i">-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">-->
              <!--                                                <div v-if="item.doc_type == 'doc'" class="doc-img"><img src='./../assets/doc.svg' class="image"/></div>-->
              <!--                                              </div>-->
              <!--                                            </td>-->
              <!--                                            <td><div class="td-wrapper">-->
              <!--                                              {{item.title}}-->
              <!--                                            </div></td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper">-->
              <!--                                                {{item.description}}-->
              <!--                                              </div>-->
              <!--                                            </td>-->
              <!--                                            <td><div class="td-wrapper" v-if="item.category_id && categoryOptions && categoryOptions.length">-->
              <!--                                              <span v-if="categoryOptions.find(obj => obj.id === item.category_id)">{{$t(categoryOptions.find(obj => obj.id === item.category_id).title)}}</span>-->
              <!--                                            </div></td>-->
              <!--                                            <td class="price"><div class="td-wrapper">{{ item.user_price }} {{$parent.currency}}</div></td>-->
              <!--                                            <td>-->
              <!--                                              <div class="td-wrapper offer-link" v-if="item.status == 'offer'" @click="openOffer(item)">{{$t('Offer')}}</div>-->
              <!--                                              <div class="td-wrapper" v-else>{{ item.status }}</div>-->
              <!--                                            </td>-->
              <!--                                          </tr>-->
              <!--                                          </tbody>-->
              <!--                                        </table>-->
              <!--                                      </div>-->
              <!--                                    </div>-->
              <!--                                  </div>-->
              <!--                  </div>-->

              <!--                  <div class="content" v-if="activeProfilePage === 'main'">-->
              <!--                    <div class="content-wrapper withdraw-content-wrapper main-content-wrapper">-->
              <!--                      <div class="balance-block">-->
              <!--                        <div class="balance-block-wrapper">-->
              <!--                          <div class="desc">{{$t('Current balance')}} :</div>-->
              <!--                          <div class="title small">{{ balance }} {{ $parent.currency }}</div>-->
              <!--                          <button class="button blue" @click="$parent.openTopUpModal">{{$t('Top Up')}}</button>-->
              <!--                        </div>-->
              <!--                      </div>-->
              <!--                      <div class="table-container table-container-depositHistory">-->
              <!--                        <div class="depositHistory-top">-->
              <!--                          <div class="title small">{{$t('Transaction History')}}</div>-->
              <!--                          <div class="depositHistory-sort">-->
              <!--                            <button v-if="sortDate" class="button" @click="clearSortDepositHistory">{{$t('Clear')}}</button>-->
              <!--                            <div class="select-container">-->
              <!--                              <input class="mob" type="date" v-model="sortDate" :placeholder="$t('Find by date')" @change="sortDepositHistory"/>-->
              <!--                              <datepicker v-model="sortDate" :placeholder="$t('Find by date')" @input="sortDepositHistory"></datepicker>-->
              <!--                            </div>-->
              <!--                            <div class="select-container">-->
              <!--                              <select v-model="sort" @change="sortDepositHistory">-->
              <!--                                <option selected hidden disabled value="">{{$t('Sort by date')}}</option>-->
              <!--                                <option value="asc">{{$t('By date: Oldest to Newest')}}</option>-->
              <!--                                <option value="desc">{{$t('By date: Newest to Oldest')}}</option>-->
              <!--                              </select>-->
              <!--                            </div>-->
              <!--                          </div>-->
              <!--                        </div>-->
              <!--                        <div class="table">-->
              <!--                          <table>-->
              <!--                            <thead>-->
              <!--                            <tr v-if="$parent.depositHistory && $parent.depositHistory.length">-->
              <!--                              <td>-->
              <!--                                <div class="td-wrapper">{{$t('Date')}}</div>-->
              <!--                              </td>-->
              <!--                              <td>-->
              <!--                                <div class="td-wrapper">{{$t('Type')}}</div>-->
              <!--                              </td>-->
              <!--                              <td>-->
              <!--                                <div class="td-wrapper">{{$t('Sum')}}</div>-->
              <!--                              </td>-->
              <!--                              <td>-->
              <!--                                <div class="td-wrapper">{{$t('Status')}}</div>-->
              <!--                              </td>-->
              <!--                            </tr>-->
              <!--                            <tr v-else>-->
              <!--                              <td></td>-->
              <!--                            </tr>-->
              <!--                            </thead>-->
              <!--                            <tbody v-if="$parent.depositHistory && !$parent.depositHistory.length">-->
              <!--                            <tr>-->
              <!--                              <td class="bold">{{$t("Unfortunately, you don't have a purchase history yet.")}}</td>-->
              <!--                            </tr>-->
              <!--                            </tbody>-->
              <!--                            <tbody v-if="$parent.depositHistory && $parent.depositHistory.length">-->
              <!--                            <tr v-for="(item,i) in $parent.depositHistory" :key="i">-->
              <!--                              <td><div class="td-wrapper">{{$parent.formatDate(item.created_at)}}</div></td>-->
              <!--                              <td>-->
              <!--                                <div class="td-wrapper">-->
              <!--                                  {{item.type}}-->
              <!--                                </div>-->
              <!--                              </td>-->
              <!--                              <td class="price"><div class="td-wrapper price">{{item.sum}} {{item.currencyCode}}</div></td>-->
              <!--                              <td><div class="td-wrapper">-->
              <!--                <span-->
              <!--                    :class="['status',-->
              <!--                  {'red': item.status === 'Error'},-->
              <!--                  {'green': item.status === 'Success'}-->
              <!--                  ]"-->
              <!--                >{{item.status}}</span>-->
              <!--                              </div></td>-->
              <!--                            </tr>-->
              <!--                            </tbody>-->
              <!--                          </table>-->
              <!--                        </div>-->
              <!--                      </div>-->
              <!--                    </div>-->
              <!--                    &lt;!&ndash; <div class="upload-button button" @click="$parent.goToPromtCreate">-->
              <!--                      <img class="img" src="./../assets/upload.svg"/>-->
              <!--                      <div class="desc">Загрузить файлы</div>-->
              <!--                    </div> &ndash;&gt;-->
              <!--                  </div>-->

              <!--                  <div class="content" v-if="activeProfilePage === 'profile-edit'">-->
              <!--                    <div class="tab-list">-->
              <!--                      <div :class="['item title small', {'active': activeSettingsTab == item.page}]" v-for="item in settingsTabs" :key="item.page" @click="setSettingsActiveTab(item.page)">{{$t(item.title)}}</div>-->
              <!--                    </div>-->
              <!--                    <div class="content-wrapper">-->
              <!--                      <div class="table-container personal-info" v-if="activeSettingsTab === 'personal'">-->
              <!--                        <div class="table-container-wrapper">-->
              <!--                          <div class="title big">{{$t('Personal Information')}}</div>-->
              <!--                          <div class="input-container">-->
              <!--                            <div class="desc"><span class="red">*</span> {{$t('Email')}}:</div>-->
              <!--                            <input type="email" :placeholder="$t('Email')" v-model="email"/>-->
              <!--                          </div>-->
              <!--                          <div class="input-container">-->
              <!--                            <div class="desc"><span class="red">*</span> {{$t('Phone')}}:</div>-->
              <!--                            <input type="number" :placeholder="$t('Phone')" v-model="phone"/>-->
              <!--                          </div>-->
              <!--                          <div class="input-container">-->
              <!--                            <div class="desc"><span class="red">*</span> {{$t('Nickname')}}:</div>-->
              <!--                            <input type="text" :placeholder="$t('Enter nickname')" v-model="nickname"/>-->
              <!--                          </div>-->
              <!--                          <div class="input-container">-->
              <!--                            <div class="desc"><span class="red">*</span> {{$t('Name')}}:</div>-->
              <!--                            <input type="text" :placeholder="$t('Enter name')" v-model="name"/>-->
              <!--                          </div>-->
              <!--                          <div class="input-container">-->
              <!--                            <div class="desc"><span class="red">*</span> {{$t('Surname')}}:</div>-->
              <!--                            <input type="text" :placeholder="$t('Enter surname')" v-model="surname"/>-->
              <!--                          </div>-->
              <!--                          <div class="button-container">-->
              <!--                            <button class="button blue" @click="updateProfileData">-->
              <!--                              <span>{{$t('Update')}}</span>-->
              <!--                            </button>-->
              <!--                          </div>-->
              <!--                          <transition name="fade">-->
              <!--                            <div class="desc red" v-if="profileUpdateErrorMessage">{{$t(profileUpdateErrorMessage)}}</div>-->
              <!--                          </transition>-->
              <!--                          <transition name="fade">-->
              <!--                            <div class="desc green" v-if="profileUpdateSuccessMessage">{{$t(profileUpdateSuccessMessage)}}</div>-->
              <!--                          </transition>-->
              <!--                        </div>-->
              <!--                      </div>-->
              <!--                      <div class="table-container password" v-if="activeSettingsTab === 'password'">-->
              <!--                        <div class="table-container-wrapper">-->
              <!--                          <div class="input-container">-->
              <!--                            <div class="desc"><span class="red">*</span> {{$t('Old Password')}}:</div>-->
              <!--                            <input type="password" :placeholder="$t('Enter old password')" v-model="curPass"/>-->
              <!--                          </div>-->
              <!--                          <div class="input-container">-->
              <!--                            <div class="desc"><span class="red">*</span> {{$t('New Password')}}:</div>-->
              <!--                            <input type="password" :placeholder="$t('Enter new password')" v-model="newPass"/>-->
              <!--                          </div>-->
              <!--                          <div class="input-container">-->
              <!--                            <div class="desc"><span class="red">*</span> {{$t('Repeat New Password')}}:</div>-->
              <!--                            <input type="password" :placeholder="$t('Repeat new password')" v-model="repeatPass"/>-->
              <!--                          </div>-->
              <!--                          <button class="button blue" @click="updatePassword">-->
              <!--                            <span>{{$t('Update')}}</span>-->
              <!--                          </button>-->
              <!--                          <transition name="fade">-->
              <!--                            <div class="desc red" v-if="passUpdateErrorMessage">{{$t(passUpdateErrorMessage)}}</div>-->
              <!--                          </transition>-->
              <!--                          <transition name="fade">-->
              <!--                            <div class="desc green" v-if="passUpdateSuccessMessage">{{$t(passUpdateSuccessMessage)}}</div>-->
              <!--                          </transition>-->
              <!--                        </div>-->
              <!--                      </div>-->
              <!--                    </div>-->
              <!--                  </div>-->

              <!--                </div>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import VTooltip from "v-tooltip";
import Vue from "vue";

Vue.use(VTooltip);
// import Datepicker from 'vuejs-datepicker';
import moment from "moment";
import OrderHistoryRow from "@/components/OrderHistoryRow.vue";

export default {
  name: "Profile",
  components: {
    OrderHistoryRow,
    // Datepicker
  },
  props: ["orderHistory", "userName", "createdHistory"],
  data: function () {
    return {
      moment,
      email: "",
      name: "",
      surname: "",
      phone: "",
      nickname: "",
      website: "",
      fb_url: "",
      ig_url: "",
      tt_url: "",
      joined: "",
      balance: "",
      avatar_path: "",
      profileUpdateSuccessMessaage: "",
      profileUpdateErrorMessaage: "",
      curPass: "",
      newPass: "",
      repeatPass: "",
      passUpdateSuccessMessaage: "",
      passUpdateErrorMessaage: "",
      activeProfilePage: "",
      withdrawName: "",
      withdrawEmail: "",
      profileNav: [
        // {
        //   page: 'profile-edit',
        //   title: 'Edit profile'
        // },

        {
          page: "main",
          title: "My purchases",
        },
        {
          page: "my-poducts",
          title: "My Work",
        },
        {
          page: "purchased-poducts",
          title: "Purchase history",
        },
      ],
      nav: [
        {
          title: "My Work",
          page: "my-work",
        },
        {
          title: "Order history",
          page: "order-history",
        },
        {
          title: "Edit profile",
          page: "edit-profile",
        },
        {
          title: "Change password",
          page: "change-password",
        },
      ],
      myProductsTabs: [
        {
          page: "art",
          title: "Art",
        },
        {
          page: "text",
          title: "Text",
        },
      ],
      settingsTabs: [
        {
          page: "personal",
          title: "Персональная информация",
        },
        {
          page: "password",
          title: "Смена пароля",
        },
      ],
      transactionTabs: [
        {
          page: "deposits",
          title: "Пополнение",
        },
        {
          page: "sell",
          title: "Продажа",
        },
      ],
      activeTransactionTab: "deposits",
      activeMyProductsTab: "art",
      activeSettingsTab: "personal",
      categoryOptions: [],
      profileIsEditable: false,
      createdHistoryImage: [],
      createdHistoryText: [],
      verification_data: "",
      userBalance: "",
      activeDownloadSize: "",
      activeDownloadFormat: "",
      activeDocDownloadFormat: "",
      resizeOptions: [],
      formatOptions: [],
      docFormatOptions: [],
      sort: "desc",
      sortDate: "",
    };
  },

  watch: {
    "$route.params.page"(newPage) {
      this.activeProfilePage = newPage;
    },
    userName: function () {
      this.getProfileData();
    },
    createdHistory: function (newArr) {
      this.createdHistoryImage = newArr.filter(
        (item) => item.doc_type == "image"
      );
      this.createdHistoryText = newArr.filter((item) => item.doc_type == "doc");
    },
  },

  mounted() {
    this.activeProfilePage = this.$route.params.page;
    this.getProfileData();
    this.getCategories();
    this.getDownloadOptions();
    this.createdHistoryImage = this.$parent.createdHistory.filter(
      (item) => item.doc_type == "image"
    );
    this.createdHistoryText = this.$parent.createdHistory.filter(
      (item) => item.doc_type == "text"
    );
    this.getOfferHistory();
  },
  methods: {
    clearSortDepositHistory() {
      this.sortDate = "";
      this.sortDepositHistory();
    },
    sortDepositHistory() {
      if (this.sortDate) {
        this.sortDate = moment(this.sortDate).format("YYYY-MM-DD");
      }
      console.log(this.sortDate);
      this.$emit("getDepositHistory", this.sort, this.sortDate);
    },
    openOffer(item) {
      this.$emit("openOffer", item);
    },
    getOfferHistory() {
      this.$http
        .get(process.env.VUE_APP_API + "offer/history")
        .then((res) => {
          console.log(res);
        })
        .catch(() => {});
    },
    getDownloadOptions() {
      this.$http
        .get(process.env.VUE_APP_API + "download-options")
        .then((res) => {
          this.resizeOptions = res.data.payload.resize_options;
          this.formatOptions = res.data.payload.format_options;
          this.docFormatOptions = res.data.payload.doc_formats;
          this.activeDownloadSize = res.data.payload.resize_options[0];
          this.activeDownloadFormat = res.data.payload.format_options[0];
          this.activeDocDownloadFormat = res.data.payload.doc_formats[0];
        })
        .catch((res) => {
          this.$emit("setNewError", res.response.data.message);
        });
    },
    deletePrompt(id) {
      this.$emit("deactivateCreatedItem", id);
    },
    downloadProduct(product) {
      console.log(product);

      let data;
      if (product.product_type == "doc") {
        data = {
          id: product.id,
          product_type: product.info?.product_type || product.product_type,
        };
      } else {
        data = {
          id: product.id,
          size: this.activeDownloadSize,
          format: this.activeDownloadFormat,
          product_type: product.info?.product_type || product.product_type,
        };
      }
      this.$http
        .get(`${process.env.VUE_APP_API}user/media/download`, {
          params: data,
          responseType: "blob", // Важно для скачивания файлов
        })
        .then((response) => {
          // Получаем имя файла из Content-Disposition
          const contentDisposition = response.headers["content-disposition"];
          let filename = `${product.name}.${
            product.product_type == "doc"
              ? this.activeDocDownloadFormat
              : this.activeDownloadFormat
          }`; // fallback имя

          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(
              /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            );
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, "");
              // Декодируем URI-encoded имена (например, %20 в пробелы)
              filename = decodeURIComponent(filename);
            }
          }

          // Создаем временную ссылку для скачивания
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();

          // Очистка
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.$emit(
            "setNewError",
            error.response?.data?.message ||
              error.message ||
              "Не удалось скачать файл"
          );
        });
    },
    editProfile() {
      if (this.profileIsEditable === true) {
        this.updateProfileData();
        this.profileIsEditable = false;
      } else {
        this.profileIsEditable = true;
      }
    },
    getFilenameFromContentDisposition(contentDisposition) {
      const match =
        /filename\*=UTF-8''([^;]*)/.exec(contentDisposition) ||
        /filename="([^"]*)"/.exec(contentDisposition);
      if (match && match[1]) {
        return decodeURIComponent(match[1]);
      } else {
        return "downloaded-file";
      }
    },
    saveFile(blob, filename) {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    },
    getCategories() {
      this.$http
        .get(process.env.VUE_APP_API + "categories")
        .then((res) => {
          this.categoryOptions = res.data.payload;
        })
        .catch(() => {});
    },
    updateProfileData() {
      let profileData = {
        email: this.email,
        name: this.name,
        phone: this.phone,
        surname: this.surname,
        // "nickname": this.nickname,
        // "web_url": this.website,
        // "fb_url": this.fb_url,
        // "ig_url": this.ig_url,
        // "tt_url": this.tt_url
      };
      this.$http
        .put(process.env.VUE_APP_API + "user/profile", profileData)
        .then((res) => {
          if (res.data.status == "OK") {
            this.profileUpdateSuccessMessaage = "Success";
            setTimeout(() => {
              this.profileUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
          this.profileUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.profileUpdateErrorMessaage = "";
          }, 3000);
        });
    },
    updatePassword() {
      let passwordList = {
        cur_password: this.curPass,
        new_password: this.newPass,
        repeat_password: this.repeatPass,
      };
      this.$http
        .post(process.env.VUE_APP_API + "user/change-password", passwordList)
        .then((res) => {
          if (res.data.status == "OK") {
            this.passUpdateSuccessMessaage = "Success";
            (this.curPass = ""), (this.newPass = ""), (this.repeatPass = "");
            setTimeout(() => {
              this.passUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
          this.passUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.passUpdateErrorMessaage = "";
          }, 3000);
        });
    },
    goToProfilePage(page) {
      this.$router.push({ path: "/profile/" + page });
      this.activeProfilePage = page;
    },
    setActiveMyProductsTab(page) {
      this.activeMyProductsTab = page;
    },
    setActiveTransactionTab(page) {
      this.activeTransactionTab = page;
    },
    setSettingsActiveTab(page) {
      this.activeSettingsTab = page;
    },
    getProfileData() {
      this.$http
        .get(process.env.VUE_APP_API + "user/profile")
        .then((res) => {
          this.email = res.data.email;
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
          this.joined = res.data.created_at;
          this.balance = res.data.balance;
          this.nickname = res.data.nickname;
          this.website = res.data.web_url;
          this.fb_url = res.data.fb_url;
          this.ig_url = res.data.ig_url;
          this.tt_url = res.data.tt_url;
          this.avatar_path = res.data.avatar_path;
          this.verification_data = res.data.verification_data;
          this.userBalance = res.data.balance;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    editPrompt(item) {
      this.$emit("editPrompt", item);
    },
  },
};
</script>
